import React, { Component } from 'react'
import { Label, Table, Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap'
import DatetimeRenderer from "../../../../../Material/DatetimeRenderer"
import Loader from "../../../../../Material/Loader"
import gql from 'graphql-tag'
import '../DriverDetailNew.css'
import { graphql } from '@apollo/client/react/hoc'
import moment from 'moment-timezone'
import withApolloClient from "../../../../../withApolloClient"
import toTitleCase from "../../../../../Functions/toTitleCase"

const AllDriverNotifications = gql`query AllDriverNotifications($driverId: ID!, $first: Int!, $cursor: String, $orderBy: [String]){
    allDriverNotifications(driverId: $driverId, pushOnly: true, first: $first, after: $cursor, orderBy: $orderBy){
        edges{
            node{
                id
                pk
                title
                message
                channel
                isRead
                dateAdded
                notificationType {
                    id
                    name
                }
            }
        }
        pageInfo {
            endCursor
            hasNextPage
        }
    }
}
`

class NotificationsTab extends Component {
    constructor(props) {
        super(props)
        this.state = {
            selectedNotification: null,
        }
    }

    toggleModal = (notification) => {
        this.setState({ selectedNotification: notification || null })
    }

    renderChannel = (channel) => channel ? toTitleCase(channel) : "--"

    renderStatus = (isRead) => isRead ? "Read" : "Unread"

    renderDate = (dateAdded) => dateAdded ? <DatetimeRenderer datetime={dateAdded} format={moment.HTML5_FMT.DATETIME_LOCAL} /> : "--"

    renderSortableHeader = (id, name) => {
        const primaryOrder = (this.props.orderBy || [])[0]
        const icon = primaryOrder === id ? 'fa-sort-asc' : primaryOrder === "-" + id ? 'fa-sort-desc' : 'fa-sort'
        return (
            <th key={id} onClick={() => this.props.updateOrder(id)} style={{ cursor: "pointer" }}>
                <Label>
                    <i className={"fa " + icon}></i>
                    &nbsp;&nbsp;{name}
                </Label>
            </th>
        )
    }

    render() {
        const notifications = this.props.allDriverNotifications && this.props.allDriverNotifications.edges
            ? this.props.allDriverNotifications.edges
            : []

        if (this.props.loading && notifications.length === 0) {
            return <div className="tab-container"><Loader /></div>
        }

        if (notifications.length === 0) {
            return <div className="tab-container"><p className="text-center">No App Notifications Found</p></div>
        }

        return (
            <div className="tab-container">
                <Table>
                    <thead>
                        <tr>
                            {this.renderSortableHeader("dateAdded", "Date Sent")}
                            {this.renderSortableHeader("title", "Title")}
                            {this.renderSortableHeader("channel", "Channel")}
                            <th><Label>Type</Label></th>
                            {this.renderSortableHeader("isRead", "Status")}
                            <th><Label></Label></th>
                        </tr>
                    </thead>
                    <tbody>
                        {notifications.map((notification, i) =>
                            <tr key={i}>
                                <td>
                                    <p className="columnContent">{this.renderDate(notification.node.dateAdded)}</p>
                                </td>
                                <td>
                                    <p className="columnContent">{notification.node.title || "--"}</p>
                                </td>
                                <td>
                                    <p className="columnContent">{this.renderChannel(notification.node.channel)}</p>
                                </td>
                                <td>
                                    <p className="columnContent">{notification.node.notificationType ? notification.node.notificationType.name : "--"}</p>
                                </td>
                                <td>
                                    <p className="columnContent">{this.renderStatus(notification.node.isRead)}</p>
                                </td>
                                <td>
                                    <a className="driver-list-button" onClick={() => this.toggleModal(notification.node)}>Show Details</a>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </Table>
                {this.props.allDriverNotifications && this.props.allDriverNotifications.pageInfo && this.props.allDriverNotifications.pageInfo.hasNextPage &&
                    <div className="text-center">
                        <Button outline color="secondary" onClick={this.props.loadMoreDriverNotifications}>Load More</Button>
                    </div>
                }
                {this.state.selectedNotification &&
                    <Modal isOpen={!!this.state.selectedNotification} toggle={() => this.toggleModal(null)} size="lg">
                        <ModalHeader>Notification Details</ModalHeader>
                        <ModalBody>
                            <p><strong>Title:</strong> {this.state.selectedNotification.title || "--"}</p>
                            <p><strong>Date Sent:</strong> {this.renderDate(this.state.selectedNotification.dateAdded)}</p>
                            <p><strong>Channel:</strong> {this.renderChannel(this.state.selectedNotification.channel)}</p>
                            <p><strong>Type:</strong> {this.state.selectedNotification.notificationType ? this.state.selectedNotification.notificationType.name : "--"}</p>
                            <p><strong>Status:</strong> {this.renderStatus(this.state.selectedNotification.isRead)}</p>
                            <p><strong>Message:</strong></p>
                            <p>{this.state.selectedNotification.message || "--"}</p>
                        </ModalBody>
                        <ModalFooter>
                            <Button outline color="secondary" onClick={() => this.toggleModal(null)}>Close</Button>
                        </ModalFooter>
                    </Modal>
                }
            </div>
        )
    }
}

const NotificationsTabWithData =
    graphql(AllDriverNotifications, {
        options: ({ id, orderBy }) => ({ variables: { driverId: id, first: 25, orderBy }, fetchPolicy: 'network-only', notifyOnNetworkStatusChange: true, }),
        props({ data: { allDriverNotifications, loading, fetchMore, variables } }) {
            return {
                allDriverNotifications, loading, variables,
                loadMoreDriverNotifications: () => {
                    return fetchMore({
                        query: AllDriverNotifications,
                        variables: {
                            ...variables,
                            cursor: allDriverNotifications.pageInfo.endCursor,
                        },
                        updateQuery: (previousResult, { fetchMoreResult }) => {
                            return {
                                allDriverNotifications: {
                                    edges: [...previousResult.allDriverNotifications.edges, ...fetchMoreResult.allDriverNotifications.edges],
                                    pageInfo: fetchMoreResult.allDriverNotifications.pageInfo,
                                    __typename: previousResult.allDriverNotifications.__typename,
                                },
                            }
                        },
                    })
                },
            }
        }
    })(withApolloClient(NotificationsTab))

class NotificationsTabContainer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            orderBy: ["-dateAdded"],
        }
    }

    updateOrder = (field) => {
        const newPrimary = this.state.orderBy[0] === field ? "-" + field : field
        const order = newPrimary === "dateAdded" || newPrimary === "-dateAdded" ? [newPrimary] : [newPrimary, "-dateAdded"]
        this.setState({ orderBy: order })
    }

    render() {
        return <NotificationsTabWithData {...this.props} orderBy={this.state.orderBy} updateOrder={this.updateOrder} />
    }
}

export default NotificationsTabContainer
